import type { UserNetworkLeader } from '@ms/yammer-data/dist/state/types';
import { trimBasenameAndNetworkFromUrlPath, trimLeadingAndTrailingSlash } from '@ms/yammer-libs-url-path-support';

export const adminSettingsUrl = '/admin';
export const adminSettingsLeadershipIdentificationUrl = '/admin/leadership-identification';
export const adminSettingsLeadershipManagementLogUrl = '/admin/leadership-identification/activity';
export const adminSettingsManageDataUrl = '/admin/data-export';
export const adminSettingsManageUsersUrl = '/admin/manage-users';
export const adminSettingsInformationBarrierSettingsUrl = '/admin/information-barrier-settings';
export const adminSettingsExternalNetworksSettingsUrl = '/admin/external-networks-settings';
export const adminSettingsBrandCenterUrl = '/admin/brand-center';
export const adminSettingsManageLeaderUrl = '/admin/leadership-identification/manage/:userId';
export const adminSettingsManageRolesUrl = '/admin/manage-roles';
export const adminSettingsTenantSettingsUrl = '/admin/tenant-settings';
export const adminSettingsConversationSettingsUrl: string = `${adminSettingsTenantSettingsUrl}/conversation-settings`;
export const adminSettingsManageStorylineUrl = '/admin/storyline';
export const adminSettingsManageStorylineAdvancedUrl = '/admin/storyline/advanced';
export const adminSettingsManageUserAchievementsUrl = '/admin/manage-achievements';
export const adminSettingsNetworkQuestionsUrl = '/admin/network-questions';
export const adminSettingsNetworkSegmentationUrl = '/admin/segmentation';
export const adminSettingManageAnalyticsUrl = '/admin/analytics';
export const adminSettingsGroupAgentEnabledCommunitiesUrl = '/admin/analytics/agent-access';
export const adminSettingsLeadershipCornerUrl = '/admin/leadership-corner';
export const adminSettingsDesignateLeaderUrl = '/admin/leadership-identification/designate-leader';
export const adminSettingsMTOPolicyUrl = '/admin/mto-policy';
export const adminSettingsSetupExternalNetworkUrl = '/admin/setup-external-network';
export const adminSettingsOrgDataQualityUrl = '/admin/org-data-quality';

export const queryParamSelected = 'selected';

type AdminSettingsManageLeaderPageWithLeaderId = (leaderId: UserNetworkLeader['id']) => string;
export const adminSettingsManageLeaderPageWithLeaderId: AdminSettingsManageLeaderPageWithLeaderId = (leaderId) =>
  adminSettingsManageLeaderUrl.replace(':userId', leaderId);

type IsAdminSettingsSubRoute = (pathname: string) => boolean;
export const isAdminSettingsSubRoute: IsAdminSettingsSubRoute = (pathname: string) => {
  const trimmedPath = trimBasenameAndNetworkFromUrlPath(pathname);
  const pathParts = trimLeadingAndTrailingSlash(trimmedPath).split('/');

  return pathParts[0] === 'admin' && pathParts.length > 1;
};
